// Placeholder "Travel Services" coming-soon page (to be filled in when owner provides details)
import React from "react";
import { Plane, Car, MapPin, Clock, Phone } from "lucide-react";
import { useLang } from "@/i18n/LanguageProvider";
import { SectionTitle, Reveal } from "@/components/Reveal";
import { waUrl, BOOK_MESSAGE } from "@/lib/contact";

const COMING_SOON = {
  en: {
    eyebrow: "Travel & Transport",
    title: "Explore Bali, Your Way",
    subtitle:
      "Trusted drivers, scenic tours and reliable airport transfers — curated to help you experience the best of Bali from Pererenan.",
    teaser: "Our full travel services menu is launching soon. In the meantime, contact us on WhatsApp for custom arrangements.",
    services: [
      { icon: Plane, t: "Airport Transfers", d: "Private pickup & drop-off between Ngurah Rai (DPS) and Pererenan." },
      { icon: Car, t: "Private Driver / Day Tour", d: "Comfortable car with English-speaking driver for Bali day trips." },
      { icon: MapPin, t: "Custom Island Itinerary", d: "Ubud, Nusa Penida, waterfalls, temples — tailored to your pace." },
    ],
    cta: "Request a quote on WhatsApp",
    note: "Launching soon",
  },
  id: {
    eyebrow: "Travel & Transportasi",
    title: "Jelajahi Bali Sesuai Gaya Anda",
    subtitle:
      "Driver terpercaya, tour scenic, dan antar jemput bandara — dirancang untuk membantu Anda menikmati keindahan Bali dari Pererenan.",
    teaser: "Menu lengkap layanan perjalanan kami akan segera hadir. Sementara ini, hubungi kami via WhatsApp untuk pengaturan khusus.",
    services: [
      { icon: Plane, t: "Antar Jemput Bandara", d: "Jemput & antar privat dari/ke Ngurah Rai (DPS) ke Pererenan." },
      { icon: Car, t: "Private Driver / Tour Harian", d: "Mobil nyaman dengan driver berbahasa Inggris untuk tour Bali." },
      { icon: MapPin, t: "Itinerary Custom", d: "Ubud, Nusa Penida, air terjun, pura — disesuaikan dengan ritme Anda." },
    ],
    cta: "Minta penawaran via WhatsApp",
    note: "Segera hadir",
  },
};

const TRAVEL_MESSAGE = `Hello Agung Wiwin Homestay,

I'd like to inquire about your travel / transport services.

Service type:
Date needed:
Pickup location:
Number of passengers:

Thank you.`;

export default function Travel() {
  const { lang } = useLang();
  const t = COMING_SOON[lang] || COMING_SOON.en;

  return (
    <div className="pb-24" data-testid="travel-page">
      <section className="container-px mx-auto pt-10 pb-6">
        <SectionTitle eyebrow={t.eyebrow} title={t.title} subtitle={t.subtitle} />
      </section>

      <section className="container-px mx-auto">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-moss/10 via-cream to-sand/40 border border-sand p-8 md:p-14">
            <div className="absolute -right-10 -bottom-10 w-72 h-72 rounded-full bg-moss/10 blur-3xl" />
            <div className="relative max-w-2xl">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-moss text-cream text-xs tracking-widest uppercase mb-6">
                <Clock className="w-3.5 h-3.5" /> {t.note}
              </div>
              <h2 className="font-display text-3xl md:text-5xl text-ink mb-5 leading-tight">
                {t.title}
              </h2>
              <p className="text-ink/70 text-base md:text-lg leading-relaxed mb-8">{t.teaser}</p>
              <a
                data-testid="travel-wa-btn"
                href={waUrl(TRAVEL_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-moss text-cream text-sm hover:bg-ink transition-colors"
              >
                <Phone className="w-4 h-4" /> {t.cta}
              </a>
            </div>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 mt-10">
          {t.services.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.08}>
              <div className="h-full bg-white rounded-2xl border border-sand p-7 hover:shadow-lg transition-shadow">
                <div className="w-11 h-11 rounded-full bg-moss/10 grid place-items-center text-moss mb-5">
                  <s.icon className="w-5 h-5" />
                </div>
                <div className="font-display text-xl text-ink mb-2">{s.t}</div>
                <p className="text-ink/70 text-sm leading-relaxed">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
